import { useStore } from 'zustand'

import { loginStore } from '../store'

export const useLoginStore = () => {
  return useStore(loginStore)
}
